import { NextSearchParams } from '@/types/general'

import { PLPPageProps, PLPPages, PLPSlug } from '@/app/(plp)/types'

export const QueryKeys = {
    HomePage: {
        HomeProperties: (slug: string, isPreview: boolean) => ['home-page-properties', { slug, isPreview }],
        Stories: ['homepage-stories'],
    },
    Cart: {
        MyCart: ['cart-my-cart'],
        POPList: ['cart-pop-list'],
        MySubCarts: ['cart-my-sub-carts'],
        CartCount: ['cart-cart-count'],
    },
    Checkout: {
        Provinces: ['checkout-provinces'],
        Cities: (provinceId: string) => ['checkout-cities', provinceId],
        LastAddress: ['checkout-last-address'],
        AddressesList: ['checkout-addresses-list'],
        LocationValidation: (provinceId: string, cityId: string, addressId: string) => [
            'checkout-location-validation',
            { provinceId, cityId, addressId },
        ],
        ShippingCapacities: (
            cityId: string,
            latitude: number | null,
            longitude: number | null,
            hasCoordinate: boolean
        ) => ['checkout-shipping-capacities', { cityId, latitude, longitude, hasCoordinate }],
        NarcoShippingCapacities: (
            cityId: string,
            latitude: number | null,
            longitude: number | null,
            hasCoordinate: boolean
        ) => ['checkout-narco-shipping-capacities', { cityId, latitude, longitude, hasCoordinate }],
        NarcoShippingCapacitiesDetails: (
            shippingMethodId: string,
            cityId: string,
            latitude: number | null,
            longitude: number | null,
            selfPickupCenterId: string | null
        ) => [
            'checkout-narco-shipping-capacities-details',
            { shippingMethodId, cityId, latitude, longitude, selfPickupCenterId },
        ],
        ConvertCoordinateToAddress: (latitude: number | null, longitude: number | null) => [
            'checkout-convert-coordinate-to-address',
            { latitude, longitude },
        ],
        NarcoSelfPickupCenters: (cityId: string, latitude: number | null, longitude: number | null) => [
            'checkout-narco-self-pickup-centers',
            { cityId, latitude, longitude },
        ],
        vendorShippingDetails: (
            vendorIdsKey: { vendors: { vendorId?: string | null; leadTime?: string | null }[] },
            vendorRequestsLength: number
        ) => ['checkout-vendor-shipping-details', { vendorIdsKey, vendorRequestsLength }],
    },
    Map: {
        SearchMap: (debouncedQuery: string, cityId: string) => ['search-map', { debouncedQuery, cityId }],
    },
    User: {
        UserInfo: ['user-user-info'],
        JwtToken: ['user-jwt-token'],
    },
    Profile: {
        Favorites: (pageNumber: number | 'INFINITE') => ['profile-favorites', { pageNumber }],
        OrdersList: (status?: string) => ['profile-orders-list', { status }],
        SearchOrder: (orderNumber: string) => ['profile-search-order', { orderNumber }],
        OrderDetail: (orderNumber: string) => ['profile-order-detail', { orderNumber }],
        UserWallet: ['profile-user-wallet'],
    },
    Layout: {
        MenuBrands: (query: string) => ['layout-menu-brands', { query }],
        LayoutMenu: ['layout-layout-menu'],
        Search: (ut: string, debouncedQuery: string) => ['layout-search', { ut, debouncedQuery }],
        SearchImpressionSeenIds: ['search-impression-seen-ids'],
    },
    PLP: {
        BasicMeta: (page: PLPPages, slug?: PLPSlug) => ['plp-basic-metas', { page, slug }],
        PagesData: (populatedSearchParam?: PLPPageProps['searchParams']) => [
            'plp-pages-data',
            { populatedSearchParam },
        ],
        ProductsCount: (stringifyedPopulatedSearchParams: string) => [
            'plp-products-count',
            { stringifyedPopulatedSearchParams },
        ],
        PriceRange: (url: string) => ['plp-price-range', { url }],
        PLPBanner: (
            cat_id: NonNullable<PLPPageProps['searchParams']>[string],
            tag_id: NonNullable<PLPPageProps['searchParams']>[string]
        ) => ['plp-plp-banner', { cat_id, tag_id }],
        BrandCategoriesCombinationList: (brand_id: string) => ['brand-categories-combination-list', { brand_id }],
        CombinationsList: (cat_id: string) => ['combinations-list', { cat_id }],
    },
    Payment: {
        Success: (paymentId: string) => ['payment-success', { paymentId }],
    },
    PDP: {
        ProductData: (slug: string) => ['pdp-product-data', { slug }],
        AlsoBoughtPDP: (slug: string) => ['pdp-also-bought-products-pdp', { slug }],
        AlsoBoughtCart: ['pdp-also-bought-products-cart'],
        Similars: (slug: string) => ['pdp-similars', { slug }],
        Complementaries: (slug: string) => ['pdp-complementaries', { slug }],
        Wishlist: (id: string) => ['pdp-wishlist', { id }],
        Comments: (id: string, pageNumber: number) => ['pdp-comments', { id, pageNumber }],
        CommentsImages: (id: string, photosPageSize: number) => ['pdp-comments-images', { id, photosPageSize }],
        SponsoredAds: (product_id: string, ut: string) => ['pdp-sponsored-ads', { product_id, ut }],
    },
    App: {
        AppSettings: ['app-app-settings'],
        MapTiles: ['map-tiles'],
    },
    Widgets: {
        Popup: (cat_id?: string, tag_id?: string, brand_id?: string, isHomePage?: boolean) => [
            'widgets-popup',
            { cat_id, tag_id, brand_id, isHomePage },
        ],
        HeaderBanner: ['widgets-header-banner'],
    },
    Interactify: {
        ShortInit: (shortSlug: string, userToken: string) => ['interactify-short-init', { shortSlug, userToken }],
        ShortsList: (requestParams: NextSearchParams) => ['interactify-shorts-list', { requestParams }],
        SingleShort: (slug: string) => ['interactify-single-short', { slug }],
        Categories: ['interactify-categories-list'],
        Labels: ['interactify-labels-list'],
    },
}
